import { ROLES } from 'config';
import { includes } from 'lodash';

import template from './header.html';
import './header.styl';

function headerComponent($scope, $rootScope, $localStorage, $mdMedia, $state, AuthService) {

  'ngInject';

  this.user = {};

  this.currentNavItem = 'login';

  this.authenticated = AuthService.isAuthenticated();

  this.storage = $localStorage;

  this.pendingFields = 0;

  $scope.$mdMedia = $mdMedia;

  this.showCompanyLogo = () => this.user && this.user.logo && $mdMedia('gt-xs');

  this.hasRole = (role) => {
    let result = false;
    const user = AuthService.getAuthenticatedUser();
    if (user && user.roles) {
      result = includes(user.roles, role);
    }
    return result;
  };

  this.hasUserRole = () => this.hasRole(ROLES.USER);

  this.hasAdminRole = () => this.hasRole(ROLES.ADMIN);

  this.initRoles = () => {
    this.isUser = this.hasUserRole();
    this.isAdmin = this.hasAdminRole();
  };

  this.getUserMenu = () => {
    if (this.user) {
      if (this.user.name) {
        return this.user.name;
      }
      return this.user.email;
    }
    return '';
  };

  this.loadUser = () => {
    if (AuthService.isAuthenticated()) {
      this.user = AuthService.getAuthenticatedUser();
      this.email = this.user.email;
      this.logo = this.user.logo;
      console.log(JSON.stringify(this.user));
    }
  };

  this.refreshPendingFields = () => {
    const user = AuthService.getAuthenticatedUser();
    this.pendingFields = 0;
    if (user) {
      if (!user.cif) {
        this.pendingFields += 1;
      }
      if (!user.companyName) {
        this.pendingFields += 1;
      }
    }
  };

  $scope.$watch('$localStorage.user', () => {
    console.log('USER UPDATED. RELOADING ROLES...');
    this.initRoles();
    this.refreshPendingFields();
    this.loadUser();
  });

  $rootScope.$on('authenticated', (event, data) => {
    console.log('Authenticated event received');
    this.authenticated = data;
    this.initRoles();
    this.refreshPendingFields();
    this.loadUser();
  });

  this.openMenu = ($mdOpenMenu, ev) => {
    $mdOpenMenu(ev);
  };

  this.logout = () => {
    console.log('Logout!');

    AuthService.logout()
    .then(() => {
      // $rootScope.$broadcast('authenticated', false);
      // AuthService.clearCredentials();
      $state.go('login');
    }).catch((err) => {
      // logout error
      console.error(`Logout error: ${err}`);
    }).finally(() => {
      // regardless of the response, change the loading state
      this.loading = false;
    });
  };

  this.goto = (page) => {
    this.currentNavItem = page;
  };

  function getCurrentLinkFromRoute(state) {
    console.log(`State changed to ${state.name}`);
    return state.name;
  }

  $rootScope.$on('$stateChangeSuccess', (event, next) => {
    this.currentNavItem = getCurrentLinkFromRoute(next);
  });

  if (AuthService.isAuthenticated()) {
    this.initRoles();
    this.loadUser();
  }

}

export default {
  template,
  controller: headerComponent,
};



// WEBPACK FOOTER //
// ./src/containers/header/header.js